import { render, staticRenderFns } from "./SaasXml.vue?vue&type=template&id=4386086e"
import script from "./SaasXml.vue?vue&type=script&lang=js"
export * from "./SaasXml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports